import React from "react";

const inlineMarkdownPattern = /\*{3}(\S(?:[^\n]*?\S)?)\*{3}|\*{2}(\S(?:[^\n]*?\S)?)\*{2}|\*(\S(?:[^\n]*?\S)?)\*/g;

export function parseInlineMarkdown(value) {
  const text = String(value ?? "");
  const parts = [];
  let lastIndex = 0;
  let match;

  inlineMarkdownPattern.lastIndex = 0;

  while ((match = inlineMarkdownPattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const key = `inline-markdown-${match.index}`;

    if (match[1] !== undefined) {
      parts.push(
        <strong key={key} className="font-[bolder]">
          <em className="italic">{match[1]}</em>
        </strong>
      );
    } else if (match[2] !== undefined) {
      parts.push(<strong key={key} className="font-[bolder]">{match[2]}</strong>);
    } else {
      parts.push(<em key={key} className="italic">{match[3]}</em>);
    }

    lastIndex = inlineMarkdownPattern.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
}

export default function InlineMarkdown({ children }) {
  return <>{parseInlineMarkdown(children)}</>;
}
